import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { IMonHocFilterReducer } from "../../reducer-model/category/IMonHocReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMonHocActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IMonHoc[],
  LOAD_ERRR: "",

  CHANGE_FILTER:{} as IMonHocFilterReducer,

  SHOW_EDIT_MODAL: {} as IMonHoc | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IMonHoc,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: {} as IIdsRequest,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",

  CHANGE_SELECTED_IDS: {} as number[]

};
export const eMonHocActionIds = generateActionTypeIds(
  eMonHocActionsObj,
  "MON_HOC"
);
export type IMonHocActionTypes = IGenericActionType<
  typeof eMonHocActionsObj,
  "MON_HOC"
>;
